import { computed } from 'vue'
import { useStore } from 'vuex'
import { useApi } from './useApi'

const SYMBOL = { CAD: 'C$', USD: 'U$' }

export function useCurrency() {
  const store = useStore()
  const { get, put } = useApi()

  const userCurrency = computed(() => store.getters['auth/user']?.currency || 'CAD')
  const rate = computed(() => store.getters['settings/cadUsdRate'] ?? 0.73)

  // T8: only a real rate (above 0) goes in the store. No rate answers null, and Number(null) is 0,
  // so every U$ price would show U$0.00. Prices keep the store's start value instead (7.4.4).
  const fetchRate = async () => {
    const res = await get('/get-cad-usd-rate')
    if (res.success && res.data.rate > 0) store.commit('settings/SET_RATE', res.data.rate)
    return res
  }

  const saveRate = async (newRate) => {
    const res = await put('/update-cad-usd-rate', { rate: newRate })
    if (res.success) store.commit('settings/SET_RATE', res.data.rate)
    return res
  }

  const format = (amount, currency = userCurrency.value, rateOverride = null) => {
    const n = Number(amount) || 0
    const r = rateOverride ?? rate.value
    const converted = currency === 'USD' ? n * r : n
    return `${SYMBOL[currency]}${converted.toFixed(2)}`
  }

  // An amount that is ALREADY in this currency, with commas: C$48,200.00 (T11). The dashboard's
  // API converts each total by its own rate, so format() above would convert it a 2nd time.
  const formatAmount = (amount, currency = 'CAD') => {
    const n = Number(amount) || 0
    return `${SYMBOL[currency]}${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }

  return { userCurrency, rate, fetchRate, saveRate, format, formatAmount }
}
